import styled from 'styled-components';

export const SCategoryName = styled.span`
  background: ${props =>
    props.inverse ? props.theme.colors.primary : props.theme.colors.accent};
  padding: 5px 10px;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 10px;
  a {
    color: #fff !important;
  }
`;
